var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer__inner"},[_c('p',{staticClass:"address",domProps:{"innerHTML":_vm._s(_vm.$t('footer.address'))}}),_vm._v(" "),_c('p',{staticClass:"copyright",domProps:{"innerHTML":_vm._s(_vm.$t('footer.copyright'))}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f7db424","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Footer.vue
// module id = null
// module chunks = 